import { Flex, Grid, Image } from "antd";
import { useTranslation } from "react-i18next";
import CalendarBlankFilled from "../../../../../../assets/images/icons/CalendarBlankFilled";
import ClockFilled from "../../../../../../assets/images/icons/ClockFilled";
import MapPinFilled from "../../../../../../assets/images/icons/MapPinFilled";
import { P1, P2 } from "../../../../../../components/NormalFonts";
import { sessionType } from "../../../../../../enumerations/sessionType";
import useGetTimezone from "../../../../../../hooks/Timezone/timezone.hooks";
import { moneyFormat } from "../../../../../../plugins/numberFormat";
import { SessionItemProps } from "./data";
import styles from "./styles.module.scss";

const SessionItem: React.FC<SessionItemProps> = ({
  data,
  containerStyle = "",
  nickname,
}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const { toLocalTimezone, formatDate } = useGetTimezone();

  const renderSessionTime = () => {
    let result = "";
    switch (data?.session_type) {
      case sessionType.ALL_DAY:
        result += t("search.fullday");
        break;
      case sessionType.MORNING:
        result += t("search.morning");
        break;
      case sessionType.AFTERNOON:
        result += t("search.afternoon");
        break;
      default:
        result += t("search.fullday");
    }
    result += ` ${data?.class_start_at}~${data?.class_end_at}`;
    return result;
  };

  return (
    <div
      className={`${styles.itemContainer} ${
        screens.sm ? "" : styles.mobile
      } ${containerStyle}`}
    >
      <div className={styles.dateWrapper}>
        {nickname ? (
          <>
            <CalendarBlankFilled
              style={{ color: "var(--primary)", fontSize: 24 }}
            />
            <P1 weight="medium" color="var(--primary)">
              {formatDate(toLocalTimezone(data.date))}
            </P1>
          </>
        ) : (
          <>
            <MapPinFilled style={{ color: "var(--primary)", fontSize: 24 }} />
            <P1 weight="medium" color="var(--primary)">
              {t(`skiresort.${data.ski_resort_code}`)}
            </P1>
          </>
        )}
      </div>

      <div className={styles.imageContainer}>
        <Image
          src={data.session_img}
          preview={false}
          width={72}
          height={72}
          style={{ objectFit: "cover", borderRadius: 8 }}
        />
        <div className={styles.detailContainer}>
          <P2 color="var(--text-content-1)">{data.session_name}</P2>
          {nickname ? null : (
            <Flex align="center" gap={8}>
              <CalendarBlankFilled style={{ fontSize: 14 }} />
              <P2 color="var(--text-content-1)">
                {formatDate(toLocalTimezone(data.date))}
              </P2>
            </Flex>
          )}
          <Flex
            vertical={screens.sm ? false : true}
            align={"flex-start"}
            justify="space-between"
            gap={8}
            style={{ width: "100%" }}
          >
            <div className={styles.dateWrapper}>
              <ClockFilled
                style={{ fontSize: 14, color: "var(--text-content2)" }}
              />
              <P2 color="var(--text-content-1)">{renderSessionTime()}</P2>
            </div>
            <Flex
              vertical
              flex={1}
              align="flex-end"
              style={{ width: screens.sm ? "auto" : "100%" }}
            >
              <Flex>
                <P2 className={styles.priceTitle} color="var(--text-content-3)">
                  {t("order.amount")}:
                </P2>
                <P2
                  className={styles.price}
                  weight="medium"
                  color="var(--text-content-2)"
                >
                  {`${t(
                    `currency.${process.env.REACT_APP_CURRENCY}`
                  )} ${moneyFormat(
                    (data?.price || 0) + (data?.extra_charge || 0)
                  )}`}
                </P2>
              </Flex>
              {nickname ? (
                <Flex style={{ marginTop: 8 }}>
                  <P2
                    className={styles.priceTitle}
                    color="var(--text-content-3)"
                  >
                    {t("recordDetail.instructorFee")}:
                  </P2>
                  <P2
                    className={styles.price}
                    weight="medium"
                    color="var(--text-content-2)"
                  >
                    {`${t(
                      `currency.${process.env.REACT_APP_CURRENCY}`
                    )} ${moneyFormat(data.instructor_fee)}`}
                  </P2>
                </Flex>
              ) : null}
            </Flex>
          </Flex>
        </div>
      </div>
    </div>
  );
};

export default SessionItem;
